import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconTextMax = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M41.29 18.002l-3.687-6.174 3.481-5.831h-2.675l-2.144 3.601-2.144-3.601h-2.675l3.481 5.848-3.67 6.157h2.675l2.332-3.91 2.332 3.91h2.693z M28.411 18.002h2.573l-4.219-12.005h-2.932l-4.202 12.005h2.555l0.72-2.161h4.785l0.72 2.161zM23.661 13.629l1.646-4.905 1.646 4.905h-3.293z M18.457 5.998h-2.435l-3.43 5.677-3.447-5.677h-2.435v12.005h2.367v-7.769l3.378 5.556h0.274l3.378-5.574v7.786h2.349v-12.005z" }),
    width: 48,
});

export { IconTextMax };
